import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { INaturalTextBehavior } from "../../../../documaker/domain/format/objects";

export interface INaturalTextBehaviorPropertyEditable {
  naturalTextBehavior(): IPropertyEditable<INaturalTextBehavior>;
}

export function instanceOfINaturalTextBehaviorPropertyEditable(instance: any): instance is INaturalTextBehaviorPropertyEditable {
  return instance
      && instance.naturalTextBehavior
      && instanceOfIPropertyEditable<INaturalTextBehavior>(instance.naturalTextBehavior());
}
